/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************************************!*\
  !*** ./src/assets/js/hero-market-banner.js ***!
  \*********************************************/
function docReady(fn) {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(fn, 3000);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

docReady(function () {
  var bgSwiper = document.querySelector('.hero-market-bg-swiper');
  var bgSwiperSlider = new Swiper(bgSwiper, {
    slidesPerView: 1,
    spaceBetween: 5,
    loop: false,
    centeredSlides: false,
    touchMoveStopPropagation: true,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }
  });
  var heroSwiper = document.querySelector('.hero-market-slider-swiper');
  var heroSwiperSlider = new Swiper(heroSwiper, {
    slidesPerView: 1,
    spaceBetween: 5,
    loop: false,
    centeredSlides: false,
    thumbs: {
      swiper: bgSwiper
    },
    control: bgSwiper,
    navigation: {
      nextEl: ".hero-market-slider-swiper .swiper-button-next",
      prevEl: ".hero-market-slider-swiper .swiper-button-prev"
    },
    on: {
      slideChange: function slideChange() {
        var activeIndex = this.activeIndex;
        var pagination = document.querySelector(".hero-market-slider-swiper .swiper-inner-pagination");

        if (pagination) {
          document.querySelectorAll(".hero-market-slider-swiper .swiper-inner-pagination .active").forEach(function (dash) {
            return dash.classList.remove('active');
          });
          document.querySelectorAll(".hero-market-slider-swiper .swiper-inner-pagination [data-index=\"".concat(this.activeIndex, "\"]")).forEach(function (dash) {
            return dash.classList.add('active');
          });
        }
      }
    }
  });
  document.querySelectorAll('.swiper-inner-pagination__dash').forEach(function (dash) {
    dash.addEventListener('click', function () {
      var index = this.dataset.index;
      heroSwiperSlider.slideTo(index);
    });
  });
});
/******/ })()
;